<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import {Link} from "@inertiajs/vue3";
export default {
  mixins: [Datatable],
  components: {Link, App, Card},
}
</script>

<template>
  <App title="Kortingsbundels">
    <template #topButtons>
      <Link :href="route('price_bundles.create')" class="btn btn-primary me-2">
        <i class="bi bi-plus-lg"></i>
        Kortingsbundel toevoegen
      </Link>
    </template>

    <Card class="mb-4">
      <Table ref="table" id="price_bundles" :config="tableConfig"/>
    </Card>
  </App>
</template>